import { connect } from "react-redux";
import { Actions as ACTIONS } from "../../store/actions/permissionActions";
import { UserPlusIcon } from "../common/icons/Solid";
import Tooltip from "@/tooltip";

const InviteManagerButton = ({ openModal, isDemo }) => {
	return (
		<>
			<button
				type="button"
				className="btn btn-default"
				onClick={openModal}
				disabled={isDemo}
			>
				<Tooltip
					content={"Cannot invite Managers during Demo"}
					isOpen={isDemo ? undefined : false}
                    arrowSize={4}
                    distance={10}
				>
					<UserPlusIcon style={{ height: "1.5em", float: "left" }} />
					<div style={{ float: "left", paddingLeft: 5 }}>Invite</div>
				</Tooltip>
			</button>
		</>
	);
};

const mapStateToProps = (state, ownProps) => {
	return {
		isDemo: state.company?.settings?.isDemo,
	};
};

const mapDispatchToProps = (dispatch) => ({
	openModal: () => dispatch(ACTIONS.inviteManagerModal(true)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InviteManagerButton);
